<template>
  <main>
    <IeMessage v-if="$store.getters.isIE" />
    <router-view v-else />

    <ModalProduct v-if="$store.getters.getModalOpen && !$store.getters.isIE" />

    <TheLoader v-if="$store.getters.getGlobalLoading && !$store.getters.isIE" />

    <ShoppingSetupModal v-if="showSetupModal" />
  </main>
</template>

<script>
import IeMessage from '@/views/Common/IeMessage';
import TheLoader from '@/components/TheLoader';
import ModalProduct from '@/components/ModalProduct';
import ShoppingSetupModal from '@/components/Configurator/ShoppingSetupModal';

export default {
  components: {
    IeMessage,
    ModalProduct,
    TheLoader,
    ShoppingSetupModal,
  },
  data () {
    return {
      showSetupModal: false
    };
  },
};
</script>
